var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex flex-col gap-4", class: _vm.errorShow ? "error" : "" },
    [
      _c(
        "div",
        {
          staticClass: "grid lg:grid-cols-4 gap-[8px] sm:gap-8 lg:gap-[8px]",
          class: _vm.options.length == 3 ? "sm:grid-cols-3" : "sm:grid-cols-2",
        },
        _vm._l(_vm.options, function (option) {
          return _c(
            "label",
            {
              key: option.id,
              staticClass:
                "input-radio-button-wrapp relative h-14 sm:h-[72px] flex justify-center items-center text-sm text-current cursor-pointer group",
            },
            [
              _c("input", {
                staticClass: "absolute w-0 h-0 opacity-0 peer",
                attrs: { type: _vm.inputType, name: _vm.name },
                on: {
                  change: function ($event) {
                    return _vm.$emit("input", option.id)
                  },
                },
              }),
              _vm._v(" "),
              _c("span", {
                staticClass:
                  "block absolute inset-0 border border-gray/20 peer-checked:bg-blue peer-checked:border-white peer-focus-visible:shadow-[0_0px_0px_5px_rgba(255,255,255,0.2)] group-hover:shadow-[0_0px_0px_5px_rgba(255,255,255,0.2)] peer-focus-visible:rounded-md group-hover:rounded-md duration-300",
              }),
              _vm._v(" "),
              _c(
                "svg",
                {
                  staticClass:
                    "w-0 h-3 opacity-0 peer-checked:w-4 peer-checked:mr-3 peer-checked:opacity-100 duration-300 z-10 stroke-2",
                },
                [_c("use", { attrs: { "xlink:href": "#icon-check" } })]
              ),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "relative z-10 whitespace-nowrap select-none" },
                [_vm._v("\n        " + _vm._s(option.text) + "\n      ")]
              ),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.errorShow
        ? _c("p", { staticClass: "text-xs text-red" }, [
            _vm._v(_vm._s(_vm.errorText)),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }